import React from 'react';
import { useTrackAppFirstOpen } from 'shared/hooks/use-track-app-first-open';

// Below AppWrapper's Suspense boundary: the hook reads the suspending user query, which from AppWrapper's body would blank every route.
export const AppTracking: React.FC = () => {
  useTrackAppFirstOpen();

  return null;
};
